import { api } from '../Api';
import { requirePortalAccess, sessionRequest } from '../PortalSession';
import { validatePreferences } from './registry';
import { epoch, utc, revision } from './contract';

export function validatePreferenceEnvelope(value) {
  if (!value || !epoch(value.scope_epoch) || !utc(value.server_time_utc) ||
      !revision(value.revision)) throw new Error('Invalid sound settings response');
  return { ...value, preferences: validatePreferences(value.preferences) };
}

export const accountSoundPreferences = {
  async load(signal) {
    requirePortalAccess();
    return sessionRequest(async (requestSignal) => validatePreferenceEnvelope(
      await api.get('/deliveryops/me/alert-preferences', {}, { cache: 'no-store', signal: requestSignal })
    ), signal);
  },
  async save(value, signal) {
    requirePortalAccess();
    if (!revision(value.revision)) throw new Error('Invalid preference revision');
    validatePreferences(value.preferences);
    return sessionRequest(async (requestSignal) => validatePreferenceEnvelope(
      await api.put('/deliveryops/me/alert-preferences', value, { cache: 'no-store', signal: requestSignal })
    ), signal);
  },
};
